package tech.gensert.portal.common.model

import kotlinx.serialization.Serializable

@Serializable
actual open class BaseModel(actual var id: String? = null)